export default __webpack_public_path__ + "8c6c3953950600cde706e699e8297179.svg";